module.exports = __webpack_public_path__ + "40790fa598db8deb17b96afe226e694e.png";